import { useGetAccessControlsQuery } from '../../../__generated__/chirp/com/hubspot/ai/access/controls/rpc/AiAccessControlsChirpService.hooks';
export const useGetAiAccessControls = () => {
  const {
    data: aiAccessControls,
    loading,
    error
  } = useGetAccessControlsQuery();
  return {
    aiAccessControls,
    loading,
    error
  };
};